import styled, { css } from 'styled-components';
import Icon from '@anwb/icon';
import { pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
import { imageStyles } from '../../styles/image.styled';
/**
 * ImageError Container
 */
export const imageErrorContainerStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: ${pxToRem(theme.spacing['100'])};
	padding: ${pxToRem(theme.spacing['400'])};
	aspect-ratio: 4 / 3;
	background-color: ${theme.colors.light.bgMediaPlaceholder};
	color: ${theme.colors.informative.textDescription};
`;
export const ImageErrorContainer = styled.div `
	${imageStyles}
	${imageErrorContainerStyles}
`;
/**
 * ImageError Message
 */
export const imageErrorMessageStyles = ({ theme }) => css `
	margin: 0;
	color: ${theme.colors.informative.textDescription};
	text-decoration: none;
	text-align: center;
`;
export const ImageErrorMessage = styled(Typography) `
	${imageErrorMessageStyles}
`;
/**
 * ImageError Icon
 */
export const imageErrorIconStyles = ({ theme }) => css `
	display: none;
	color: ${theme.colors.medium.iconInactive};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		display: block;
	}
`;
export const ImageErrorIcon = styled(Icon).attrs({
    variant: 'image',
    type: 'illustrative',
    size: 'xxl',
}) `
	${imageErrorIconStyles}
`;
//# sourceMappingURL=image-error.styled.js.map